import { Validators } from '@angular/forms';
import { authConstants } from '../../auth/auth.constants';
import { FormControlValidatorService } from '../sharedServices/form-control-validator.service';

export class SharedAuthValidator {
  constructor(private validator: FormControlValidatorService) {}

  getEmail(value = ''): { [key: string]: any } {
    return [value, [Validators.required, this.validator.isValidEmail()]];
  }

  getPassword(value = ''): { [key: string]: any } {
    return [value, Validators.required];
  }

  getPasswordChecker(value = ''): { [key: string]: any } {
    return [value, this.validator.isValidPasswordChecker('password', authConstants.passwordCheckerParams)];
  }

  getPhone(value = ''): { [key: string]: any } {
    return [value, [Validators.required, Validators.minLength(10), this.validator.isValidPhone()]];
  }

  getPersonNames(value = ''): { [key: string]: any } {
    return [value, [Validators.required, this.validator.isAlphabetical()]];
  }

  getCityId(value = 0): { [key: string]: any } {
    return [value, Validators.min(1)];
  }

  getPostalCode(showPostalCode = false, value = ''): { [key: string]: any } {
    return showPostalCode ? [value, [Validators.required, this.validator.isNumeric()]] : [value];
  }

  getDocumentType(value = 0): { [key: string]: any } {
    return [value, Validators.min(1)];
  }

  getDocumentNumber(isMX = false, value = ''): { [key: string]: any } {
    return this.getCommonDocumentNumber(isMX, value);
  }

  getCompanyName(value = '', special = false): { [key: string]: any } {
    return special
      ? [value, [Validators.required, this.validator.isAlphanumericSpecial()]]
      : [value, [Validators.required, this.validator.isAlphanumeric()]];
  }

  getCompanyDocumentType(value = 0): { [key: string]: any } {
    return [value, Validators.min(1)];
  }

  getCompanyDocumentNumber(isMX = false, value = ''): { [key: string]: any } {
    return this.getCommonDocumentNumber(isMX, value);
  }

  getVerificationCode(value = 0): { [key: string]: any } {
    return [
      value,
      [Validators.required, Validators.maxLength(1), this.validator.isNumeric(), this.validator.min(0), this.validator.max(9)],
    ];
  }

  getVerificationCodeCreate(isMX = false, value = ''): { [key: string]: any } {
    return [value, isMX ? [] : [Validators.required, this.validator.isNumeric(), this.validator.min(0), this.validator.max(9)]];
  }

  getCompanyPhone(value = ''): { [key: string]: any } {
    return [value, [Validators.required, Validators.minLength(7), this.validator.isValidPhone()]];
  }

  getContactName(value = ''): { [key: string]: any } {
    return [value, [Validators.required, this.validator.isAlphabetical()]];
  }

  getSegmentationRange(value = 0) {
    return [value, [Validators.min(1)]];
  }

  private getCommonDocumentNumber(isMX = false, value = ''): { [key: string]: any } {
    return isMX
      ? [value, [Validators.required, this.validator.isAlphanumeric()]]
      : [value, [Validators.required, this.validator.isNumeric()]];
  }
}
